/**
 * Shared constants for OptLab add-in
 */

// Proxy base URL - defaults to DEV
export const PROXY_BASE_URL_DEFAULT = "https://proxy-dev.exceloption.com";

// Storage keys for OfficeRuntime.storage
export const STORAGE_KEYS = {
  AUTH_SESSION: "optlab.authSession", // versioned blob {v:1, session: AuthSession}
  AUTH_TOKEN: "optlab.authToken", // deprecated; used by legacy authClient
  LAST_PING_RESULT: "optlab.lastPingResult",
  DIAG_LAST_ERROR: "optlab.diag.last_error", // JSON: { schema_version: 1, ...DiagnosticError }
  DIAG_LAST_REQUEST: "optlab.diag.last_request", // JSON: { schema_version: 1, ...lastRequest }
  DIAG_SESSION_STARTED: "optlab.diag.session_started_at", // JSON: { schema_version: 1, value: string }
  DIAG_STATS_SNAPSHOT: "optlab.diag.stats_snapshot", // JSON: { schema_version: 1, stats: {...}, recent: [...] }
  ENTITLEMENTS: "optlab.entitlements.v1",
  UPGRADE_WALL_DISMISSED_PREFIX: "optlab.upgrade_wall_dismissed:",
} as const;
